import { ReactComponent as TopInning } from 'images/topInning.svg';
import React from 'react';
import styled from 'styled-components';
import { darkgrey, grey, liveBackground, warmupBackground } from 'styles/Colors';

export const DataWrapper = styled.div`
  display: flex;
  gap: 24px;
`;

export const DataItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

export const DataLabel = styled.div`
  color: ${grey};
  font-family: Inter;
  font-size: 11px;
  font-weight: 600;
  line-height: 10px;
`;

export const DataValue = styled.div`
  overflow: hidden;
  color: ${({ theme }) => theme.dataValueColor};
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 160px;
  font-family: Inter;
  font-size: 13px;
  font-weight: 600;
  line-height: 18.2px;
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const ModeBadge = styled.div<{ isPlaying: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px 8px;
  border-radius: 4px;
  font-family: Inter;
  font-size: 11px;
  font-weight: 600;
  line-height: 10px;

  background: ${({ isPlaying }) => (isPlaying ? liveBackground : warmupBackground)};
  color: ${darkgrey};
`;

export const BottomInning = styled((props) => <TopInning {...props} />)`
  transform: rotate(180deg);
`;

export const InningWrapper = styled.div`
  svg path {
    fill: ${({ theme }) => theme.inningFill};
  }
`;
